module.exports = __webpack_public_path__ + "media/images/pages/ai/pocstock-ethical-ai-face-8@2x-9cc3adb29360a861513c0dc835d79caa.png";